import {
  OPEN_SIDEBAR,
  CLOSE_SIDEBAR,
  GET_SUCCESS,
  SET_LOADING,
} from '../types';

const agbaReducer = (state, action) => {
  switch (action.type) {
    case OPEN_SIDEBAR:
      return {
        ...state,
        sideBar: true,
      };
    case CLOSE_SIDEBAR:
      return {
        ...state,
        sideBar: false,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_SUCCESS:
      return {
        ...state,
        projects: action.payload,
        loading: false,
      };

    default:
      break;
  }
};

export default agbaReducer;
